import {immerable} from "immer";
import ExtractionSheetArticleNodeDto from "@/models/interfaces/dtos/extraction/extraction-sheet-article-node-dto.ts";
import ProjectMeasures from "@/pages/takeoff/context/project-measure/models/project-measures.ts";
import MeasureType from "@/pages/takeoff/context/project-measure/models/measure-type.ts";
import Measure from "@/pages/takeoff/context/project-measure/models/measure.ts";
import ExtractionNodeElement from "./interfaces/extraction-node-element.ts";
import ExtractionSheetArticleMeasuresElement from "./article-elements/extraction-sheet-article-measures-element.ts";
import ExtractionSheetArticleElementBase from "./article-elements/extraction-sheet-article-element-base.ts";
import ExtractionArticleElementType from "./enums/extraction-article-element-type.ts";
import ExtractionSheetArticle3DElement from "./article-elements/extraction-sheet-article-3D-element.ts";
import {
    ExtractionSheetArticle3DElementDto,
    ExtractionSheetArticleMeasuresElementDto
} from "@/models/interfaces/dtos/extraction/extraction-sheet-article-element-dto.ts";
import ProjectIndicatorsDto from "@/models/interfaces/dtos/indicators/project-indicators-dto.ts";
import IndicatorDto from "@/models/interfaces/dtos/indicators/indicator-dto.ts";

class ExtractionSheetArticleNode implements ExtractionNodeElement {
    [immerable] = true;
    
    id: string;
    
    name: string;
    
    children: ExtractionSheetArticleElementBase[];
    
    constructor(name: string) {
        this.id = crypto.randomUUID();
        this.name = name;
        this.children = [];
    }

    static fromDto(dto: ExtractionSheetArticleNodeDto, projectMeasures: ProjectMeasures, measureTypes: MeasureType[], projectIndicatorsData?: ProjectIndicatorsDto): ExtractionSheetArticleNode {
        const node = new ExtractionSheetArticleNode(dto.name);
        if(dto.children)
            node.children = dto.children.map(childDto => {
                switch (childDto.type) {
                    case ExtractionArticleElementType.MEASURE:
                        return ExtractionSheetArticleMeasuresElement.fromDto(childDto as ExtractionSheetArticleMeasuresElementDto, node.id, projectMeasures, measureTypes);
                    case ExtractionArticleElementType._3D:
                        return ExtractionSheetArticle3DElement.fromDto(childDto as ExtractionSheetArticle3DElementDto, node.id, projectIndicatorsData);
                    default:
                        throw new Error(`Unknown article element type: ${childDto.type}`);
                }
            });
        return node;
    }

    updateArticleName(articleName: string) {
        this.name = articleName;
    }
    
    linkMeasures(associatedMeasureTypeId: string, associatedMeasureTypeName: string, associatedStoreys: string[], measures: Measure[], defaultType: string | undefined, defaultUnity: string) {
        if(defaultType === undefined) return;
        this.children = []; // On garde qu'un seul enfant au final (✿◡‿◡)
        const newSheetElement = new ExtractionSheetArticleMeasuresElement(crypto.randomUUID(), this.id, associatedMeasureTypeId, associatedMeasureTypeName, associatedStoreys, measures, defaultType, defaultUnity);
        this.children.push(newSheetElement);
    }

    link3D(associatedIndicatorDef: string, associatedStoreysIds: number[], indicatorDtos: IndicatorDto[]) {
        this.children = [];
        const {def} = indicatorDtos[0];
        const _3D = indicatorDtos.map(i => i._3D);
        const newSheetElement = new ExtractionSheetArticle3DElement(crypto.randomUUID(), this.id,  associatedStoreysIds, associatedIndicatorDef, def.unity, _3D, indicatorDtos);
        this.children.push(newSheetElement);
    }

    findElementById(id: string) : ExtractionSheetArticleElementBase | undefined {
        return this.children.find(child => child.id === id);
    }
}

export default ExtractionSheetArticleNode;